module.exports = __webpack_public_path__ + "static/img/bonus_8.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_8.png
// module id = OfaK
// module chunks = 0